//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_Enlightenment_&_Revolutions.png';

const subTopics = [
  { name: 'Age of Enlightenment', route: '/History-Age-of-Enlightenment', key: 'Age of Enlightenment' },
  { name: 'American Revolution', route: '/History-American-Revolution', key: 'American Revolution' },
  { name: 'French Revolution', route: '/History-French-Revolution', key: 'French Revolution' },
  { name: 'Haitian Revolution', route: '/History-Haitian-Revolution', key: 'Haitian Revolution' },
  { name: 'Latin American Wars of Independence', route: '/History-Latin-American-Wars', key: 'Latin American Wars of Independence' }
];


function HistoryPageAOR() {
  return (
    <JourneyPage
      title="Age of Enlightenment"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageAOR;
